(ns com.theplantscape.local-store.plants-db
  (:require [com.theplantscape.local-store.core-db :refer [diag map->datascript-vec]]
            [com.theplantscape.local-store.utils :refer [namespace-map]]
            [datascript.core :as d]))


;; (d/q {:find ['?e]
;;        ;; :keys ['plant-entity-id]
;;       :where [['?e :plant/plant-entity-id '_]
;;                 #_['?e :plant/type '?plant-type]]}
;;        @diag
;;        )


;; (defn get-plant-info [plant-xt-id]
;;   (d/q {:find ['?e]
;;        ;; :keys ['plant-entity-id]
;;         :in '[$ ?plant-id]
;;         :where [['?e :plant/plant-entity-id '?plant-id]
;;                 #_['?e :plant/type '?plant-type]]}
;;        @diag
;;   plant-xt-id))

#_(defn plant [plant-entity-id]
  {:diagram.object/plant-entity-id (-> @app-state :current :plant :db/id)
   :diagram.object/plant-uuid (-> @app-state :current :plant :plant/id)
   :diagram.object/svg-filter (-> @app-state :current :plant :plant/type name)}
  )

;;(get-plant-info 14)

(defn plant-exists?
  [plant-entity-id]
  (boolean (seq
            (d/q {:find ['?e]
                  :in '[$ ?plant-entity-id]
                  :where [['?e :plant/plant-entity-id '?plant-entity-id]]}
                 @diag
                 plant-entity-id))))

(plant-exists? 14)

(defn plant-does-not-exist? [plant-entity-id]
  (not (plant-exists? plant-entity-id)))

(defn get-plant-entity-id-from-uuid [plant-xt-id]
  (d/q {:find '[?e .]
        :in '[$ ?plant-xt-id]
      :where [['?e :plant/id '?plant-xt-id]]}
       @diag
  plant-xt-id))

(defn insert-plant-data
  [plant]

  (when (plant-does-not-exist? (:plant/plant-entity-id plant))
    (prn "insert")
    (prn plant)
    (d/transact!
     diag
     (if (vector? plant)
       (mapv map->datascript-vec plant)
       (map->datascript-vec plant)))))


(comment
  (boolean (seq (plant-exists? "b1642727-a42a-4389-8653-1304ab942636")))
  (boolean (seq (plant-exists? "b1642727-a42a-4389-8653-1304ab942639")))



(d/q {:find ['?e ]
      :where [['?e :plant/id "5a126050-87d1-473f-bef8-3d5e5ec07883"]]}
       @diag
       )

(d/q {:find ['?e ]
      :where [['?e :plant/type ]]}
       @diag
       )

(d/q {:find ['?e '?plant-entity-id]
        :where [['?e :plant/plant-entity-id '?plant-entity-id]]}
       @diag
       )

  )


